<script lang="ts" setup>
import { TableConfig } from "./types";

const props = defineProps<{
  config: TableConfig;
  isVisible: boolean;
  loading: boolean;
  hideActions?: boolean;
  width?: number | string;
}>();

const emit = defineEmits<{
  (e: "update:isVisible", value: boolean): void;
  (e: "select"): void;
}>();

const dialogIsVisible = computed({
  get: () => props.isVisible,
  set: (value: boolean) => emit("update:isVisible", value),
});
</script>

<template>
  <VDialog
    :width="$vuetify.display.smAndDown ? 'auto' : (width ?? 800)"
    :model-value="dialogIsVisible"
    persistent
  >
    <!-- Dialog close btn -->
    <DialogCloseBtn @click="dialogIsVisible = false" />

    <VCard class="pa-2 pa-sm-10" :loading="loading">
      <SearchDataTable v-bind="props.config" />

      <!-- Dialog actions -->
      <VRow class="mt-5" v-if="!hideActions">
        <VCol>
          <VBtn
            color="primary"
            :loading="loading"
            class="mr-3"
            @click="emit('select')"
            >{{ $t("Select") }}</VBtn
          >
          <VBtn
            color="danger"
            v-if="!loading"
            @click="dialogIsVisible = false"
            >{{ $t("Cancel") }}</VBtn
          >
        </VCol>
      </VRow>
    </VCard>
  </VDialog>
</template>
